import { autoinject } from 'aurelia-framework';

import { APIParameters, GenericApi } from '~/api/generic-api';
import {
	AutocompleteOptions,
	AutocompleteRemoteLoader,
} from '~/components/field/common/autocomplete/autocomplete-react';
import { FetchUtils } from '~/utils/fetch-utils';

interface SuburbRequest extends APIParameters {
	// NOTE: Jake: 2018-11-14
	// I am using 'q' and 'number' to be consistent with the `api/member/search` endpoint.
	q: string;
	number?: number;
}

@autoinject
export class SuburbLoaderApi
	extends GenericApi
	implements AutocompleteRemoteLoader
{
	public getResults = (
		query: string,
		options: AutocompleteOptions,
	): Promise<any[]> | undefined => {
		if (!query) {
			return undefined;
		}
		const limit = options.limit;
		const params: SuburbRequest = {
			q: query,
		};
		if (limit !== undefined && limit !== null) {
			params.number = limit;
		}
		const url = this.generateURL(
			GenericApi.apiServerURL + 'api/suburbs',
			params,
		);
		return FetchUtils.getJSONWithParamsInURL(url);
	};
}
